// extracted by mini-css-extract-plugin
export default {"quiz":"Quiz-module__quiz--paP3x"};